import { useContext, useEffect, useState } from "react";
import MainLayout from "../Container/Layout/MainLayout";
// context
import { Context } from "../Context/Context";
// style
import styles from "../Styles/CreateTicket.module.css";
import { ErrorMessage, Formik, Form, Field } from "formik";
import {
  createTicket,
  getRoleList,
  getServiceList,
} from "../Services/ContectService";
import { toast } from "react-toastify";
import { CreateTicketSchema } from "../Components/Validations/Validation";
import { useNavigate } from "react-router-dom";

const CreateTicket = () => {
  const { json, user, setLoading } =
    useContext(Context);
  const content = json?.CreateTicket;
  const [file, setFile] = useState(null);
  // const [serviceList, setServiceList] = useState([]);
  // const [roleList, setRoleList] = useState();
  let navigate = useNavigate();

  // const serviceListHandeler = async () => {
  //   try {
  //     const { status, data } = await getServiceList(user);
  //     if (status === 200) {
  //       setServiceList(data);
  //     }
  //   } catch (error) {
  //     toast.error(json.toast.err_1);
  //   }
  // };

  // const setServiceListHandeler = async () => {
  //   try {
  //     const { status, data } = await getRoleList(user);
  //     if (status === 200) {
  //       setRoleList(data);
  //     }
  //   } catch (error) {
  //     toast.error(json.toast.err_1);
  //   }
  // };

  const createTicketHandeler = async (values) => {
    setLoading(true);
    let formdata = new FormData();
    formdata.append("subject", values.subject);
    // formdata.append("user_role", values.user_role);
    formdata.append("context", values.context);
    // formdata.append("service_code", values.service_code);
    // formdata.append("priority", values.priority);
    if (file) {
      formdata.append("file", file);
    } else {
      formdata.append("file", "");
    }

    try {
      const { status } = await createTicket(formdata, user);
      if (status === 200) {
        toast.success(json.toast.createTicket);
        navigate("/Ticket");
        // setServiceList(null);
        setLoading(false);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
    }
  };

  const setFileHandler = (ev) => {
    const newFile = ev.target.files[0];
    if (!newFile) return;
    if (newFile.size > 5 * 1024 * 1024) {
      ev.target.value = null;
      setFile(null);
      return toast.error("حداکثر حجم فایل 5 مگابایت است");
    }
    setFile(newFile);
  };

  // useEffect(() => {
     // serviceListHandeler();
     // setServiceListHandeler();

     // return () => {
     //   setTalkExpert(null);
     // };
  // }, []);

  return (
    <MainLayout>
      <Formik
        initialValues={{
          subject: "",
          // user_role: "",
          context: "",
          file,
          // service_code: talkExpert || "",
          // priority: "",
        }}
        validationSchema={CreateTicketSchema}
        onSubmit={(values) => {
          createTicketHandeler(values);
        }}
      >
        <Form className={styles.account_frame}>
          <h2 className="bold w-100 border-b pb-4 text-h4">{content.title}</h2>

          <div className="main-form-group account-form-group">
            <label className="mian-label"> {content.issue} </label>
            <div className="input-frame input-frame-two">
              <Field name="subject" type="text" />
            </div>
            <ErrorMessage
              name="subject"
              render={(msg) => <div className="main-error">{msg}</div>}
            />
          </div>

          {/* <div className="main-form-group account-form-group">
            <label className="mian-label"> {content.priority} </label>
            <div className="input-frame input-frame-two">
              <Field as="select" name="priority">
                <option className="">{content.option}</option>
                <option value="h">زیاد</option>
                <option value="l">کم</option>
              </Field>
            </div>
          </div> */}
          {/*
                    <div className="main-form-group account-form-group">
                        <label className="mian-label">  {content.service} </label>
                        <div className="input-frame input-frame-two">
                            <Field as="select" name="service_code" disabled={talkExpert ? true : false}>
                                <option className="d-none" value="">{content.option}</option>
                                {serviceList.length > 0 && (
                                    <>
                                        {serviceList.map((item, index) => (
                                            <option value={item.code} key={index}>{item.code}</option>
                                        ))}
                                    </>
                                )}
                            </Field>
                        </div>
                        <ErrorMessage
                            name="service_code"
                            render={(msg) => (
                                <div className="main-error">{msg}</div>
                            )}
                        />
                    </div>

          <div className="main-form-group account-form-group">
            <label className="mian-label"> {content.role} </label>
            <div className="input-frame input-frame-two">
              <Field as="select" name="user_role">
                <option className="d-none">{content.option}</option>
                {roleList
                  ? roleList.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.name}
                      </option>
                    ))
                  : null}
              </Field>
            </div>
            <ErrorMessage
              name="user_role"
              render={(msg) => <div className="main-error">{msg}</div>}
            />
          </div>
*/}
          <div className="main-form-group account-form-group w-100">
            <label className="mian-label"> {content.file} </label>
            <div className="input-frame input-frame-two">
              <Field
                name="file"
                type="file"
                onChange={(ev) => setFileHandler(ev)}
              />
            </div>
            <ErrorMessage
              name="file"
              render={(msg) => <div className="main-error">{msg}</div>}
            />
          </div>
          <div className="main-form-group account-form-group w-100">
            <label className="mian-label"> {content.text} </label>
            <div className="input-frame input-frame-two">
              <Field as="textarea" name="context" />
            </div>
            <ErrorMessage
              name="context"
              render={(msg) => <div className="main-error">{msg}</div>}
            />
          </div>

          <button type="submit" className="main-btn main-btn-fill">
            {" "}
            {content.button}{" "}
          </button>
        </Form>
      </Formik>
    </MainLayout>
  );
};

export default CreateTicket;
